// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "177d49e65b45d24863bb5f3cee45632f828dd0a3/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","688":"2b6b0509","774":"c5660826","777":"dfb468f1"}[chunkId] + ".chunk.js";
};